import { render, staticRenderFns } from "./avatar-shield.vue?vue&type=template&id=5fb66664&scoped=true"
import script from "./avatar-shield.vue?vue&type=script&lang=js"
export * from "./avatar-shield.vue?vue&type=script&lang=js"
import style0 from "./avatar-shield.vue?vue&type=style&index=0&id=5fb66664&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb66664",
  null
  
)

export default component.exports